import i18n from 'modules/core/lib/i18n'

const numberOfRestDaysOptions = () => {
  return [1, 2, 3, 4, 5, 6, 7].map((day: number) => {
    return {
      value: day * 100,
      label: i18n.tp('time_planning.planning_versions.forms.number_of_rest_days_option', {
        count: day,
      }),
    }
  })
}

export default numberOfRestDaysOptions
